module.exports = __webpack_public_path__ + "c5bab5eff5914d571cb758483df9c8e3.jpg";